export const OPERATOR_PERMISSIONS = [
  'lots.manage',
  'rates.manage',
  'events.manage',
  'orders.manage',
  'refunds.manage',
  'revenue.view',
  'promotions.manage',
] as const;

export type OperatorPermission = (typeof OPERATOR_PERMISSIONS)[number];

export const DEFAULT_STAFF_PERMISSIONS: OperatorPermission[] = ['orders.manage'];

export function hasPermission(
  operator: { role: 'owner' | 'staff'; permissions?: readonly string[] } | null,
  permission: OperatorPermission,
) {
  return operator?.role === 'owner' || operator?.permissions?.includes(permission) === true;
}
